import { render, staticRenderFns } from "./ListaProjetosPorParceiro.vue?vue&type=template&id=5abe2edc&scoped=true&"
import script from "./ListaProjetosPorParceiro.vue?vue&type=script&lang=js&"
export * from "./ListaProjetosPorParceiro.vue?vue&type=script&lang=js&"
import style0 from "./ListaProjetosPorParceiro.vue?vue&type=style&index=0&id=5abe2edc&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abe2edc",
  null
  
)

export default component.exports